import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.RequestApproval', {
    title: 'Get first approval',
    description: 'Approve requests from your email inbox, web app, or mobile app—anywhere, anytime.',
    buttonText: 'Start approving',
});
